import { EmptyRsp } from "../model/APIData";
import {
    CreateQuestionRsp,
    GetCreateQuestionHintRsp,
    GetQuestionRsp,
    QuestionData,
    UpdateQuestionTagsRsp,
} from "../model/question/data/data";
import { Tag } from "../model/TagData";
import { LogDebug } from "../tools/log";
import { requestBackend } from "./common";

interface GetQuestionProps {
    questionID: string;
    afterSuccess: (q: QuestionData) => void;
    dispatch: any;
}

export function GetQuestion(props: GetQuestionProps) {
    const { questionID, afterSuccess, dispatch } = props;
    const req_data = {
        id: questionID,
    };
    requestBackend({
        uri: `/api/question/get`,
        req_data: req_data,
        handleRsp: (rsp_json: any) => {
            let rsp = new GetQuestionRsp();
            LogDebug("GetQuestionRsp", rsp);
            Object.assign(rsp, rsp_json);
            afterSuccess(rsp.question_data);
            return rsp;
        },
        errTitle: "获取题目信息失败",
        dispatch,
    });
}

interface UpdateQuestionTagsProps {
    dataID: string;
    labels: string[];
    editType: number;
    afterSuccess: (tags: Tag[], d: QuestionData) => void;
    dispatch: any;
}

export function UpdateQuestionTags(props: UpdateQuestionTagsProps) {
    const { dataID, labels, dispatch, afterSuccess, editType } = props;
    const req_data = {
        data_id: dataID,
        labels: labels,
        edit_type: editType,
    };
    requestBackend({
        uri: `/api/question/update_tags`,
        req_data: req_data,
        handleRsp: (rsp_json: any) => {
            let rsp = new UpdateQuestionTagsRsp();
            Object.assign(rsp, rsp_json);
            afterSuccess(rsp.tags, rsp.data);
            return rsp;
        },
        errTitle: "保存标签失败",
        dispatch,
    });
}

interface MergeQuestionProps {
    id1: string;
    id2: string;
    force?: boolean;
    afterSuccess: () => void;
    dispatch: any;
}

export function MergeQuestion(props: MergeQuestionProps) {
    const { id1, id2, dispatch, afterSuccess, force } = props;
    const req_data = {
        id1: id1,
        id2: id2,
        force: force ? true : false,
    };
    requestBackend({
        uri: `/api/question/merge`,
        req_data: req_data,
        handleRsp: (rsp_json: any) => {
            let rsp = new EmptyRsp();
            Object.assign(rsp, rsp_json);
            afterSuccess();
            return rsp;
        },
        errTitle: "合并题目失败",
        dispatch,
        backdrop: true,
    });
}

interface CreateQuestionProps {
    category: number;
    type: number;
    textInput: string;
    afterSuccess: (id: string) => void;
    dispatch: any;
}

export function CreateQuestion(props: CreateQuestionProps) {
    const { afterSuccess, dispatch, category, type, textInput } = props;

    requestBackend({
        uri: `/api/question/create`,
        req_data: {
            category: category,
            type: type,
            text_input: textInput,
        },
        handleRsp: (rsp_json: any) => {
            let rsp = new CreateQuestionRsp();
            Object.assign(rsp, rsp_json);
            afterSuccess(rsp.id);
            return rsp;
        },
        errTitle: "创建题目失败",
        dispatch,
    });
}

interface GetCreateQuestionHintProps {
    afterSuccess: (hint: string) => void;
    dispatch: any;
}

export function GetCreateQuestionHint(props: GetCreateQuestionHintProps) {
    const { afterSuccess, dispatch } = props;

    requestBackend({
        uri: `/api/question/create_hint`,
        req_data: {},
        handleRsp: (rsp_json: any) => {
            let rsp = new GetCreateQuestionHintRsp();
            Object.assign(rsp, rsp_json);
            afterSuccess(rsp.hint);
            return rsp;
        },
        errTitle: "创建题目失败",
        dispatch,
    });
}
